import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './ReactotronConfig';

ReactDOM.render(<App />, document.getElementById('root'));
